import React from 'react';
import { Grid } from '@mui/material';

export const VaultHeader = () => {
  return (
    <Grid sx={{ pl: 2, pr: 5 }} container>
      <Grid
        container
        className="text-white font-poppins text-xs font-normal leading-3"
      >
        <Grid item lg={2} md={2} sm={4} xs={4}>
          Vaults
        </Grid>
        <Grid item lg={2} md={2} sm={4} xs={4}>
          OZK Earned
        </Grid>
        <Grid
          item
          lg={2}
          md={2}
          sx={{
            display: { xs: 'none', md: 'flex' },
          }}
        >
          OZK Staked
        </Grid>
        <Grid
          item
          lg={1.5}
          md={1.5}
          sx={{ display: { xs: 'none', md: 'block' } }}
        >
          APR
        </Grid>
        <Grid item lg={2} md={2} sm={4} xs={4}>
          Ends In
        </Grid>
        <Grid
          item
          lg={2.5}
          md={2.5}
          sx={{ display: { xs: 'none', md: 'block' } }}
        >
          Action
        </Grid>
      </Grid>
    </Grid>
  );
};
